import { Component, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../../utils/Stores/store';

@Component({
  tag: 'faq-list-item-module',
  styleUrl: 'faq-list-item-module.scss',
  shadow: true,
})
export class ModuleFaqListItem {
  @Prop() readonly faq: IWCFaq;

  render() {
    return (
      <Host>
        <div class={{ 'faq-item': true, 'faq-item--full': Store?.get('is_full') }}>
          <div
            class="faq-item-title"
            data-idFaq={this.faq?.id}
          >
            <div class="faq-item-title__text">{this.faq?.title}</div>
            <div
              class="faq-item-legend"
              data-idFaq={this.faq?.id}
            >
              <div
                class="faq-item-legend__like"
                data-idFaq={this.faq?.id}
              >
                <img
                  src={getAssetPath('./../assets/icons/like.svg')}
                  alt="Like"
                />
                {this.faq?.nb_votes}
              </div>
            </div>
          </div>
          <div class="faq-item-goTo">
            <img
              src={getAssetPath('./../assets/icons/chevron-right.svg')}
              alt={wcShared?.translate('Ouvrir la FAQ')}
            />
          </div>
        </div>
      </Host>
    );
  }
}
